module.exports = __webpack_public_path__ + "img/Bluecode.e6ee140b.png";